<h2 mat-dialog-title>Compose Client Message</h2>

<mat-dialog-content [formGroup]="form" class="dialog-body">
  <section class="hero-card">
    <div>
      <p class="eyebrow">Recipient</p>
      <h3>{{ data.client.customerName }}</h3>
      <p>{{ data.client.contactNumber }}</p>
    </div>
    <div class="hero-metrics">
      <div>
        <strong>{{ data.client.totalOrders }}</strong>
        <span>Orders</span>
      </div>
      <div>
        <strong>{{ data.client.totalSpend | currency:'NGN':'symbol':'1.0-0' }}</strong>
        <span>Spend</span>
      </div>
    </div>
  </section>

  <section class="section-card">
    <div class="section-header">
      <h3>Channels</h3>
      <small *ngIf="form.errors?.['channelRequired']" class="error-text">Select at least one channel.</small>
    </div>

    <div class="channel-grid">
      <label class="channel-option">
        <input type="checkbox" formControlName="sendSms">
        <span>
          <strong>SMS</strong>
          <small>Send immediately to the client phone number.</small>
        </span>
      </label>
      <label class="channel-option">
        <input type="checkbox" formControlName="sendEmail">
        <span>
          <strong>Email</strong>
          <small>Use when you have a verified recipient email.</small>
        </span>
      </label>
    </div>
  </section>

  <section class="section-card">
    <div class="section-header">
      <h3>Quick Templates</h3>
      <small>Start from a structured draft.</small>
    </div>

    <div class="template-grid">
      <button mat-stroked-button type="button" *ngFor="let template of templates; let i = index" (click)="useTemplate(i)">
        {{ template.label }}
      </button>
    </div>
  </section>

  <section class="section-card">
    <div class="section-header">
      <h3>Compose</h3>
      <small>Context: {{ data.client.lastPickupLocation || '-' }} -> {{ data.client.lastDeliveryLocation || '-' }}</small>
    </div>

    <div class="form-grid">
      <mat-form-field appearance="outline">
        <mat-label>Recipient email</mat-label>
        <input matInput formControlName="email" placeholder="client@example.com">
        <mat-error *ngIf="form.get('email')?.hasError('required')">Email is required for email delivery.</mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('email')">Enter a valid email address.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email subject</mat-label>
        <input matInput formControlName="subject" placeholder="Subject for email delivery">
        <mat-error *ngIf="form.get('subject')?.hasError('required')">Subject is required for email delivery.</mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Message</mat-label>
      <textarea matInput rows="7" formControlName="message" placeholder="Write a clear update for the client"></textarea>
      <mat-hint align="end">{{ messageLength }}/1000</mat-hint>
      <mat-error *ngIf="form.get('message')?.hasError('required')">Message is required.</mat-error>
      <mat-error *ngIf="form.get('message')?.hasError('maxlength')">Keep the message under 1000 characters.</mat-error>
    </mat-form-field>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">Send Message</button>
</mat-dialog-actions>
